/**
 * The health categories a subscriber can belong to.
 *
 * These are the hinge of the whole product: a subscriber's categories decide
 * which articles they receive. Labels are bilingual because the newsletters
 * are Arabic-first but the workspace is used in English.
 *
 * This list only supplies those labels. The categories the newsletter can
 * actually target come from the catalogue — see use-catalogue-categories —
 * because a label this file invents matches nothing in content_index. There
 * are deliberately no audience sizes here: a real one comes from the member
 * warehouse, and a made-up one reads as fact.
 */
export interface Category {
  id: string;
  label: string;
  labelAr: string;
}

export const CATEGORIES: Category[] = [
  { id: "nutrition", label: "Nutrition", labelAr: "التغذية" },
  { id: "pregnancy", label: "Pregnancy", labelAr: "الحمل والولادة" },
  { id: "diabetes", label: "Diabetes", labelAr: "السكري" },
  { id: "heart", label: "Heart health", labelAr: "صحة القلب" },
  { id: "mental", label: "Mental health", labelAr: "الصحة النفسية" },
  { id: "skin", label: "Skin", labelAr: "الجلدية" },
  { id: "women", label: "Women's health", labelAr: "صحة المرأة" },
  { id: "children", label: "Children's health", labelAr: "صحة الطفل" },
  { id: "weight", label: "Weight loss", labelAr: "إنقاص الوزن" },
];

export function categoryByLabel(label: string | null | undefined): Category | undefined {
  if (!label) return undefined;
  const key = label.trim().toLowerCase();
  return CATEGORIES.find(
    (c) => c.label.toLowerCase() === key || c.labelAr === label.trim() || c.id === key,
  );
}

export function categoryLabelAr(label: string | null | undefined): string {
  return categoryByLabel(label)?.labelAr ?? (label ?? "");
}
